import React from 'react';
import Marquee from 'react-fast-marquee';
import { formatTimerDisplay } from '../utils';
import { CAMPAIGN_CONFIG, ASSET_URLS } from '../constants';

const CampaignTimer = ({ remainingTime }) => {
  return (
    <div className="headderMarquee">
      {/* <div className="rightLayoutMonth"></div> */}
      <div className="leftLayoutMonth"></div>
      <Marquee speed={30} gradientColor="none" direction="left">
        <div className="wazirxHeadderTimerTitle">
          {CAMPAIGN_CONFIG.MARQUEE_TEXT} &nbsp;&nbsp;
        </div>
      </Marquee>
      <div className="campTimerContainer" style={{ width: '130px', marginLeft: '0px' }}>
        <img alt=" " className="timerIcon" src={ASSET_URLS.TIMER_ICON} />
        <div className="timeCounter">
          {remainingTime === 0 ? (
            '00:00:00'
          ) : (
            <div style={{ display: 'flex', gap: '2px', marginBottom: '2px' }}>
              {formatTimerDisplay(remainingTime)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignTimer;
